<div class="filter-modal-container">
  <div class="filter-header">Filters</div>
  <div class="filter-container">
    <ng-container *ngIf="openForm">
      <form [formGroup]="filterForm" class="filter-form">
        <ng-container>
          <!-- Skills filters for ContractorOrgView -->
          <emerald-dropdown
            *ngIf="fieldsVisibility === personaType.ContractorOrgView || fieldsVisibility === personaType.SkillsView"
            [label]="'Primary Skills'"
            [outlined]="true"
            [multiSelect]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="primarySkill"
            [options]="primarySkillOptions"
            [id]="'primary_skills_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <emerald-dropdown
            *ngIf="fieldsVisibility === personaType.ContractorOrgView  || fieldsVisibility === personaType.SkillsView"
            [label]="'Secondary Skills'"
            [outlined]="true"
            [multiSelect]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="secondarySkill"
            [options]="secondarySkillOptions"
            [id]="'secondary_skills_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <!-- Timesheet filters: native selects — the emerald menus are clipped
               and hard to scroll inside this popover -->
          <ng-container *ngIf="fieldsVisibility === personaType.Timesheet">
            <label class="fp-field">
              <span class="fp-label">Vendor</span>
              <select class="fp-select" (change)="onNativeSelect('vendor', $event)">
                <option value="" [selected]="!filterForm.value.vendor" disabled hidden>Select vendor</option>
                <option *ngFor="let o of vendorOptions" [value]="o.value" [selected]="filterForm.value.vendor?.value === o.value">{{ o.label }}</option>
              </select>
            </label>
            <label class="fp-field">
              <span class="fp-label">D&T Leader</span>
              <select class="fp-select" (change)="onNativeSelect('dntLeader', $event)">
                <option value="" [selected]="!filterForm.value.dntLeader" disabled hidden>Select leader</option>
                <option *ngFor="let o of dntLeaderOptions" [value]="o.value" [selected]="filterForm.value.dntLeader?.value === o.value">{{ o.label }}</option>
              </select>
            </label>
            <label class="fp-field">
              <span class="fp-label">Status</span>
              <select class="fp-select" (change)="onNativeSelect('status', $event)">
                <option value="" [selected]="!filterForm.value.status" disabled hidden>Select status</option>
                <option *ngFor="let o of timesheetStatusOptions" [value]="o.value" [selected]="filterForm.value.status?.value === o.value">{{ o.label }}</option>
              </select>
            </label>
            <label class="fp-field">
              <span class="fp-label">Employee Status</span>
              <select class="fp-select" (change)="onNativeSelect('employeeStatus', $event)">
                <option value="" [selected]="!filterForm.value.employeeStatus" disabled hidden>Select status</option>
                <option *ngFor="let o of employeeStatusOptions" [value]="o.value" [selected]="filterForm.value.employeeStatus?.value === o.value">{{ o.label }}</option>
              </select>
            </label>
            <label class="fp-field">
              <span class="fp-label">Location</span>
              <select class="fp-select" (change)="onNativeSelect('location', $event)">
                <option value="" [selected]="!filterForm.value.location" disabled hidden>Select location</option>
                <option *ngFor="let o of locationOptions" [value]="o.value" [selected]="filterForm.value.location?.value === o.value">{{ o.label }}</option>
              </select>
            </label>
          </ng-container>

          <!-- Vendor filter with SEARCH ENABLED -->
          <emerald-dropdown
            *ngIf="
              fieldsVisibility === personaType.ContractorOrgView ||
              fieldsVisibility === personaType.SkillsView
            "
            [label]="'Select Vendor'"
            [outlined]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="vendor"
            [options]="vendorOptions"
            [id]="'vendor_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <!-- Project filter with SEARCH ENABLED -->
          <emerald-dropdown
            *ngIf="fieldsVisibility === personaType.ContractorOrgView || fieldsVisibility === personaType.SkillsView"
            [label]="'Project Name'"
            [outlined]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="project"
            [options]="projectOptions"
            [id]="'project_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <!-- Timesheet specific filters -->
          <!-- <emerald-dropdown
            *ngIf="fieldsVisibility === personaType.Timesheet"
            [outlined]="true"
            [id]="'month_select'"
            [label]="'Month'"
            formControlName="month"
            [options]="monthOptions"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown> -->

        </ng-container>
      </form>
    </ng-container>
      <ng-container actions>
          <div class="button-container">
            <span class="mdc-dialog__button">
            <emerald-button
              [label]="'Reset'"
              [type]="'Secondary'"
              (onClick)="reset()"
            ></emerald-button>
            </span>
            <span class="mdc-dialog__button">
            <emerald-button
              [label]="'Apply'"
              [type]="'Primary'"
              (onClick)="apply()"
            ></emerald-button>
            </span>
          </div>
    </ng-container>
  </div>
</div>
